import theme from '../../base';

const input = {
  background: theme.colors.neutrals.gray850,
  disabledBackground: theme.colors.neutrals.gray800,
  border: theme.colors.neutrals.gray700,
  error: theme.colors.reds.red300,
  focusBorder: theme.colors.blues.blue200,
  text: theme.colors.neutrals.gray200,
  placeholderText: theme.colors.neutrals.gray700,
  disabledPlaceholderText: theme.colors.neutrals.gray700,
  label: theme.colors.neutrals.white,
  message: theme.colors.neutrals.gray500,
  helperLink: theme.colors.blues.blue300,
  icon: theme.colors.neutrals.gray700,
};

export default input;
